import { Dispatch } from "redux";
import request from "../../util/request";
import actions from "../../util/actions";
import errorHandler from "../../util/error-handler";

export const clearMinistryMembershipError = () => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.MINISTRY_MEMBERSHIP_HTTP_ERROR,
      payload: {
        clear: true
      }
    });
  };
};

export const getMinistryMembership = (ministry_id: string, search: string, page: number, per_page: number) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.MINISTRY_MEMBERSHIP_HTTP_LOADING
    });

    request({
      method: "get",
      pathname: "getMinistryMembership",
      params: { ministry_id, search, page, per_page }
    })
      .then((response) => {
        dispatch({
          type: actions.MINISTRY_MEMBERSHIP_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });

        dispatch({
          type: actions.SET_MINISTRY_MEMBERSHIP_DETAILS,
          payload: {
            ...response.data.content
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.MINISTRY_MEMBERSHIP_HTTP_ERROR, error, dispatch);
      });
  };
};

export const addMinistryMembership = (ministry_id: string, user_id: string) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.MINISTRY_MEMBERSHIP_HTTP_LOADING
    });

    request({
      method: "post",
      pathname: "addMinistryMembership",
      data: { ministry_id, user_id }
    })
      .then((response) => {
        dispatch({
          type: actions.MINISTRY_MEMBERSHIP_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.MINISTRY_MEMBERSHIP_HTTP_ERROR, error, dispatch);
      });
  };
};

export const deleteMinistryMembership = (ministry_id: string, user_id: string) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.MINISTRY_MEMBERSHIP_HTTP_LOADING
    });

    request({
      method: "post",
      pathname: "deleteMinistryMembership",
      data: { ministry_id, user_id }
    })
      .then((response) => {
        dispatch({
          type: actions.MINISTRY_MEMBERSHIP_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.MINISTRY_MEMBERSHIP_HTTP_ERROR, error, dispatch);
      });
  };
};
